// extracted by mini-css-extract-plugin
module.exports = {"download":"DownloadButton_download__n_Hp5"};